export default "__VITE_ASSET__HC5YynVC__"